"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vertScrollToElement = exports.horizScrollToElement = void 0;
/* eslint-disable no-mixed-operators */

var easeInOutQuad = function easeInOutQuad(currentTime, startValue, changeInValue, duration) {
  var t = currentTime;
  var b = startValue;
  var c = changeInValue;
  var d = duration;
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t -= 1;
  return -c / 2 * (t * (t - 2) - 1) + b;
};
var vertScrollToElement = function vertScrollToElement(scrollable, element) {
  var percent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var to = scrollable.clientHeight * percent;
  to = element.offsetTop - to;
  to += element.clientHeight;
  var start = scrollable.scrollTop;
  var change = to - start;
  var startDate = Date.now();
  var animateScroll = function animateScroll() {
    var currentDate = Date.now();
    var currentTime = currentDate - startDate;
    var val = easeInOutQuad(currentTime, start, change, duration);
    // eslint-disable-next-line no-param-reassign
    scrollable.scrollTop = val;
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      // eslint-disable-next-line no-param-reassign
      scrollable.scrollTop = to;
    }
  };
  animateScroll();
};

// Horizontally scroll to a specified element in a scrolling element
//
// scrollable - the scrolling element
// element - the element to scroll to
// percent - the percent of the visible portion of the scrollable to scroll the element to
// duration - the scroll animation duration
exports.vertScrollToElement = vertScrollToElement;
var horizScrollToElement = function horizScrollToElement(scrollable, element) {
  var percent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
  var to = scrollable.clientWidth * percent;
  to = element.offsetLeft - to;
  to += element.clientWidth;
  var start = scrollable.scrollLeft;
  var change = to - start;
  var startDate = Date.now();
  var animateScroll = function animateScroll() {
    var currentDate = Date.now();
    var currentTime = currentDate - startDate;
    var val = easeInOutQuad(currentTime, start, change, duration);
    // eslint-disable-next-line no-param-reassign
    scrollable.scrollLeft = val;
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      // eslint-disable-next-line no-param-reassign
      scrollable.scrollLeft = to;
    }
  };
  animateScroll();
};
exports.horizScrollToElement = horizScrollToElement;
//# sourceMappingURL=scroll.js.map